module.exports = __webpack_public_path__ + "static/media/notification_selected.cdca89d2.png";